import { useMsal } from '@azure/msal-react';
import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { MATCHING_ENGINE, MEMBERS_PORTAL } from '../../Consts';
import { AppInsightsService } from '../../../telemetry/services/AppInsightsService';

interface ISignOutProps {
    logout: () => void;
    isSignedIn: boolean;
    portalType: string;
}

export const SignOut = (props: ISignOutProps) => {
    const { instance, accounts } = useMsal();

    React.useEffect(() => {
        const doLogout = async () => {
            await props.logout();
            AppInsightsService.clearAuthenticatedUser();
            if (accounts.length > 0) {
                await instance.logoutRedirect({
                    postLogoutRedirectUri:
                        props.portalType === MEMBERS_PORTAL
                            ? `${window.location.origin}/`
                            : `${window.location.origin}/login`,
                });
            } else {
                window.location.assign(
                    props.portalType === MEMBERS_PORTAL ? "/" : "/login"
                );
            }
        };

        doLogout();
    }, []);

    return <div />;
};